import React, { Component } from 'react';
import Alert from 'components/ui/Alert';
import { Translation, withTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  Separator,
} from '@cargomatic/ui';
import PhoneField from 'components/v2/forms/PhoneField';
import { CarrierSearchCombobox } from 'components/design-system/organisms/CarrierSearchCombobox';
import UserActionCreators from '../../../actions/UserActionCreators';
import SessionStore from '../../../stores/SessionStore';

function getInitialState() {
  return {
    carrier_name: '',
    carrier: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    password: '',
    username: '',
    isCustomerManager: SessionStore.isCustomerManagerAdmin(),
  };
}

class RegisterDriver extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState();
  }

  handlePhoneChange = (phone) => {
    this.setState({ phone });
  };

  handleChange(field) {
    return (e) => this.setState({ [field]: e.target.value });
  }

  handleCustomerSelect = (item) => {
    this.setState((prevState) => ({
      ...prevState,
      carrier_name: item ? item.name || '' : '',
      carrier: item ? item._id : '',
    }));
  };

  handleRegister = (e) => {
    e.preventDefault();
    const {
      carrier_name: _carrier_name,
      isCustomerManager: _isCustomerManager,
      ...driver
    } = this.state;
    UserActionCreators.addDriver(driver);
    this.setState(getInitialState());
  };

  valid() {
    const { email, first_name, last_name, phone, password, username } =
      this.state;
    return !(email && first_name && last_name && phone && password && username);
  }

  renderForm() {
    const { t } = this.props;
    const isCustomerManager = this.state.isCustomerManager;
    const disabled = !this.state.carrier || !isCustomerManager;
    const selectedCarrier = this.state.carrier
      ? { _id: this.state.carrier, name: this.state.carrier_name }
      : null;
    return (
      <Card>
        <form onSubmit={this.handleRegister}>
          <CardHeader>
            <CardTitle>{t('ADD_DRIVER')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {!isCustomerManager && (
              <Alert type="warning">
                <Translation>
                  {(t) => <p>{t('REQUIRED_CUSTOMER_MANAGER_PRIVILEGES')}</p>}
                </Translation>
              </Alert>
            )}
            <div>
              <label className="block mb-2 text-sm font-medium">
                {t('SELECT_A_CARRIER')}
              </label>
              <div className="max-w-md">
                <CarrierSearchCombobox
                  value={selectedCarrier}
                  onValueChange={this.handleCustomerSelect}
                  disabled={!isCustomerManager}
                  placeholder={t('SEARCH_FOR_CARRIER')}
                />
              </div>
            </div>
            <Separator />
            <div>
              <h4 className="mb-4 text-sm font-medium">
                {t('DRIVER_PROFILE')}
              </h4>
              <div className="grid grid-cols-4 gap-6 max-w-3xl">
                <div className="col-span-4 sm:col-span-2">
                  <label className="block mb-2 form-label">
                    {t('FIRST_NAME')}
                  </label>
                  <input
                    type="text"
                    placeholder="John"
                    className="w-full mb-4 form-field"
                    disabled={disabled}
                    onChange={this.handleChange('first_name')}
                    value={this.state.first_name}
                  />
                </div>

                <div className="col-span-4 sm:col-span-2">
                  <label className="block mb-2 form-label">
                    {t('LAST_NAME')}
                  </label>
                  <input
                    type="text"
                    placeholder="Smith"
                    className="w-full mb-4 form-field"
                    disabled={disabled}
                    onChange={this.handleChange('last_name')}
                    value={this.state.last_name}
                  />
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <label className="block mb-2 form-label">{t('PHONE')}</label>
                  <PhoneField
                    value={this.state.phone}
                    onChange={this.handlePhoneChange}
                    disabled={disabled}
                  />
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <label className="block mb-2 form-label">
                    {t('USERNAME')}
                  </label>
                  <input
                    type="text"
                    placeholder="JohnSmith"
                    className="w-full mb-4 form-field"
                    disabled={disabled}
                    onChange={this.handleChange('username')}
                    value={this.state.username}
                  />
                </div>

                <div className="col-span-4 sm:col-span-2">
                  <label className="block mb-2 form-label">{t('EMAIL')}</label>
                  <input
                    type="email"
                    placeholder="jsmith@cargomatic.com"
                    className="w-full mb-4 form-field"
                    disabled={disabled}
                    onChange={this.handleChange('email')}
                    value={this.state.email}
                  />
                </div>

                <div className="col-span-4 sm:col-span-2">
                  <label className="mb-2 form-label">{t('PASSWORD')}</label>
                  <input
                    type="password"
                    className="block w-full mb-4 form-field"
                    disabled={disabled}
                    onChange={this.handleChange('password')}
                    value={this.state.password}
                  />
                </div>
              </div>
            </div>
          </CardContent>
          <CardFooter className="justify-end">
            <Button disabled={disabled || this.valid()} type="submit">
              {t('REGISTER')}
            </Button>
          </CardFooter>
        </form>
      </Card>
    );
  }

  render() {
    return <section>{this.renderForm()}</section>;
  }
}

export default withTranslation()(RegisterDriver);
